import React from 'react';
import { useTranslation } from 'react-i18next';

const NoticeBar = props => {
  const { t } = useTranslation();

  return (
    props.body && (
      <div
        style={{
          backgroundColor: '#faad14',
          padding: '10px 15px',
          textAlign: 'center'
        }}>
        {t(props.body)}
      </div>
    )
  );
};

export default NoticeBar;
